<body>
  <div class="main-container d-flex justify-content-center align-items-center">
    <div class="conteudo shadow-lg rounded-4 overflow-hidden">
      <!-- Mensagem de erro - posicionada dentro do conteúdo, antes do card -->
      <div *ngIf="mensagem && mensagem !== 'Autenticando e obtendo sua localização...'"
        class="alert alert-danger text-center">
        {{ mensagem }}
      </div>

      <!-- Área do formulário -->
      <div class="card border-0 bg-transparent">
        <div class="card-body">
          <h3 class="card-title text-center mb-3 fw-bold">Entrar</h3>

          <form [formGroup]="formulario" (ngSubmit)="autenticarUsuario()">
            <div class="mb-3">
              <label for="userName" class="form-label">
                Nome de usuário
              </label>
              <input type="text" class="form-control rounded-3" id="userName" formControlName="userName"
                placeholder="Digite seu nome de usuário" />
            </div>

            <div class="mb-3">
              <label for="senha" class="form-label">Senha</label>
              <div class="password-container position-relative">
                <input [type]="mostrarSenha ? 'text' : 'password'" class="form-control rounded-3" id="senha"
                  formControlName="senha" placeholder="Digite sua senha" />
                <span class="password-toggle" (click)="toggleMostrarSenha()">
                  <i class="bi" [ngClass]="mostrarSenha ? 'bi-eye-slash-fill' : 'bi-eye-fill'"></i>
                </span>
              </div>
              <small class="text-danger fw-bold"
                *ngIf="formulario.get('senha')?.invalid && formulario.get('senha')?.touched">
                A senha esta muito curta.
              </small>
            </div>

            <button type="submit" class="btn w-100 rounded-3 fw-bold" [disabled]="carregando">
              {{ carregando ? 'Processando...' : 'Entrar' }}
            </button>
          </form>

          <!-- Download do aplicativo -->
          <!-- <div class="mt-4 text-center">
            <a href="https://cedae.homologacao.vibetex.com.br/download/vibetexcedaeapp-release-v1.0.16+17.apk"
              class="app-download-link">
              <i class="bi bi-android2 me-2"></i>Baixe o aplicativo
            </a>
          </div> -->
          
        </div>
      </div>

      <!-- Área da imagem lateral -->
      <div class="foto">
        <img src="https://cedae.vibetex.com.br/images/logo_vibetex.png" alt="Logo Vibetex" />
      </div>
    </div>
  </div>
</body>